import { useEffect, useState } from 'react';
import api from '../api';

export default function useDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const res = await api.get('/api/dashboard');
        if (mounted) setData(res.data);
      } catch (e) {
        console.error('[dashboard load error]', e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return { data, loading };
}
